/**
 * Client-side migration of legacy API/transform dedupe into config.dedupe.
 * Mirrors cascade-node-server/utils/groupDedupe.js migrateGroupDedupeConfig.
 */
export function migrateGroupDedupeConfig(config) {
  const cfg = config && typeof config === 'object' ? { ...config } : {};
  const existing = cfg.dedupe && typeof cfg.dedupe === 'object' ? cfg.dedupe : null;
  if (existing && ['add', 'skip', 'update', 'sync'].includes(String(existing.mode || '').toLowerCase())) {
    return cfg;
  }

  const api = cfg.api_source && typeof cfg.api_source === 'object' ? cfg.api_source : {};
  const field = typeof api.unique_key === 'string' ? api.unique_key.trim() : '';
  const sql = typeof api.unique_key_sql === 'string' ? api.unique_key_sql.trim() : '';
  const legacyMode = String(cfg.mode || '').toLowerCase();

  if (field || sql) {
    cfg.dedupe = {
      mode: legacyMode === 'sync' ? 'update' : 'skip',
      ...(field && !sql ? { unique_key: field } : {}),
      ...(sql && !field ? { unique_key_sql: sql } : {}),
      ...(field && sql ? { unique_key: field } : {}),
    };
    return cfg;
  }

  const output = cfg.output && typeof cfg.output === 'object' ? cfg.output : {};
  const outMode = String(output.mode || '').toLowerCase();
  const outKey = String(output.unique_key || output.uniqueKey || '').trim();
  if ((cfg.type === 'transform' || cfg.type === 'transform_sql') && outMode === 'sync' && outKey) {
    cfg.dedupe = { mode: 'update', unique_key: outKey };
    return cfg;
  }

  // Legacy Google Spreadsheet / Drive "Mode" (add_only | sync)
  if (cfg.type === 'google_spreadsheet' && legacyMode === 'sync') {
    cfg.dedupe = { mode: 'sync', unique_key: 'sheet_row' };
    return cfg;
  }
  if (cfg.type === 'google_drive_folder' && legacyMode === 'sync') {
    cfg.dedupe = { mode: 'sync', unique_key: 'drive_file_id' };
    return cfg;
  }

  cfg.dedupe = { mode: 'add' };
  return cfg;
}
